import { render, staticRenderFns } from "./slides.vue?vue&type=template&id=5a4109d9&scoped=true&"
import script from "./slides.vue?vue&type=script&lang=js&"
export * from "./slides.vue?vue&type=script&lang=js&"
import style0 from "./slides.vue?vue&type=style&index=0&id=5a4109d9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a4109d9",
  null
  
)

export default component.exports